import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/User";

export const Delete = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);
export default {
  Delete,
};
